module.exports = __webpack_public_path__ + "img/arrow-down.21cd2e38.svg";